<div class="oxygen-notifications" #notificationsContainer [ngStyle]="{ top: offsetTop + 'px' }">
    <ng-container #componentHolder></ng-container>
</div>
